var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_464_2921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7396 15.9089H10.1562V12.5755H15.9896V9.24219H19.3229V15.9089H17.2396L15.9896 17.1589L14.7396 15.9089Z",
    stroke: "#9C4900",
    strokeOpacity: 0.3,
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65625 2.57812H15.9896V12.5781H8.07292L6.40625 14.2448L4.73958 12.5781H2.65625V2.57812Z",
    stroke: "#9C4900",
    strokeOpacity: 0.3,
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90885 7.57812H9.32552M11.8255 7.57812H12.2422M5.99219 7.57812H6.40885",
    stroke: "#9C4900",
    strokeOpacity: 0.3,
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_464_2921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.984375 0.078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.850fa9fc30eecb0b1b8c194062720007.svg";
export { ForwardRef as ReactComponent };